import Cookies from '../utilities/Cookies';
import PromoModalForm from '../forms/PromoModalForm';
import GtmEvent from '../analytics/GtmEvent';

// eslint-disable-next-line no-undef
const $ = jQuery;

class PromoModalController {
	constructor() {
		this.formId = 6;
		this.gtmEventCategory = 'form';
		this.gtmEventLabel = 'Tutoring Promo Form';
		this.formOpenerButton = $('.promo-modal__button.stride-button--primary');
		this.modalOpenerButton = $('.banner-link');
	}

	init() {
		const promoModalForm = new PromoModalForm();
		promoModalForm.init();
		this.conditionallyLoadModal();
		this.addEventListeners();
	}

	addEventListeners() {
		this.addFormOpenerButtonEventListener();
		this.addModalOpenerButtonEventListener();
		this.setClaimNowClickedInModalEventListener();
	}

	addFormOpenerButtonEventListener() {
		this.formOpenerButton.on('click', () => {
			$('.promo-modal-intro').addClass('hidden');
			$('.promo-modal-form').removeClass('hidden');
		});
	}

	addModalOpenerButtonEventListener() {
		this.modalOpenerButton.on('click', () => {
			this.showModal();
		});
	}

	/**
	 * GTM event - Form Showed from Modal
	 */
	setClaimNowClickedInModalEventListener() {
		$('.promo-modal .promo-modal__button.stride-button--primary').on('click', () => {
			if (!this.modalShowed) {
				this.modalShowed = true;
				GtmEvent(this.gtmEventCategory, ' Claim now, in modal clicked', this.gtmEventLabel);
			} // prettier-ignore
		}); // prettier-ignore
	}

	conditionallyLoadModal() {
		const promoModalFirstViewCookie = Cookies.get('tutoringPromo-firstView');
		if (!promoModalFirstViewCookie) {
			this.showModal();
			Cookies.set('tutoringPromo-firstView', 'true', 365);
		}
	}

	showModal() {
		// eslint-disable-next-line no-undef
		lity('#promo-modal');
	}
}

export default PromoModalController;
